import axios, { isAxiosError } from 'axios';

export const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (isAxiosError(error)) {
      const response = error.response;
      
      // Only handle 401s from authenticated endpoints
      // Don't redirect on login/register failures
      if (
        response?.status === 401 &&
        error.config &&
        !error.config.url?.includes('/auth/login') &&
        !error.config.url?.includes('/auth/register')
      ) {
        // Get the error details from the response
        const errorData = response.data;
        // Clear auth data
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        
        // If we have a redirect path in the response, use it
        const redirectPath = errorData.redirect || '/login';
        
        // Add a small delay to ensure the storage is cleared
        setTimeout(() => {
          window.location.href = redirectPath;
        }, 100);
      }
    }
    return Promise.reject(error);
  }
);

export { isAxiosError }; 